/* Poolfritz – Konfigurator fuer Poolueberdachungen.
   Datenbasis: JSON aus der Section (Metafelder modell.*). Keine Werte werden ergaenzt oder berechnet,
   ausser dem reinen Vergleich Beckenbreite <-> Modellbreite (Hinweis, keine Sperre).
   PDF: jsPDF (cdnjs), wird erst bei Bedarf geladen. */
(function () {
  'use strict';
  var root = document.querySelector('[data-pfk]');
  if (!root) return;

  var daten = [], cfg = {};
  try { daten = JSON.parse(root.querySelector('[data-pfk-daten]').textContent); } catch (e) { daten = []; }
  try { cfg = JSON.parse(root.querySelector('[data-pfk-cfg]').textContent); } catch (e) { cfg = {}; }
  var nachHandle = {}; daten.forEach(function (d) { nachHandle[d.h] = d; });

  var SPEICHER = 'pfk_konfiguration';
  var TYP_REIHE = ['Flach', 'Niedrig', 'Mittel-Hoch/Hoch'];
  var TYP_TEXT = {
    'Flach': 'Sehr flach und unauffällig – schützt das Becken, das Wasser bleibt sauber und warm.',
    'Niedrig': 'Niedrige Bauweise mit etwas mehr Luft über dem Wasser.',
    'Mittel-Hoch/Hoch': 'Genug Höhe, um unter der Überdachung zu schwimmen und sich aufzuhalten.'
  };
  var RAL = { '9010': '#f1ece1', '9006': '#a5a8a6', '9007': '#8f8f8c', '7016': '#383e42', '9005': '#0e0e10', '9016': '#f1f0ea' };

  /* ---------- Hilfsfunktionen ---------- */
  function $(s, el) { return (el || root).querySelector(s); }
  function $$(s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function zahl(x) { return x == null ? '' : String(Math.round(x * 100) / 100).replace('.', ','); }
  function spanne(a, b, e) {
    if (a == null && b == null) return '';
    if (a == null || b == null || a === b) return zahl(a == null ? b : a) + ' ' + e;
    return zahl(a) + ' – ' + zahl(b) + ' ' + e;
  }
  function istSonderfarbe(o) { return /sonderfarbe/i.test(o); }
  function lesen() { try { return JSON.parse(sessionStorage.getItem(SPEICHER) || 'null'); } catch (e) { return null; } }
  function schreiben() { try { sessionStorage.setItem(SPEICHER, JSON.stringify(z)); } catch (e) {} }

  /* ---------- Zustand ---------- */
  var z = {
    typ: '', modell: '', groesse: '', wahl: {},
    masse: { breite: '', laenge: '', abstand: false, abstandB: '', abstandL: '', notiz: '' },
    farbe: '', ral: '', optionen: [], montage: '', optNotiz: '', nr: ''
  };
  var schritt = 1, MAX = 7;
  var gesendet = !!cfg.gesendet;

  function modell() { return nachHandle[z.modell] || null; }
  function voll(d) { return d.t.indexOf(d.v) === 0 ? d.t : d.v + ' ' + d.t; }
  function anfrageNr() {
    if (!z.nr) {
      var d = new Date(), p = function (n) { return (n < 10 ? '0' : '') + n; };
      z.nr = 'PF-' + d.getFullYear() + p(d.getMonth() + 1) + p(d.getDate()) + '-' + Math.random().toString(36).slice(2, 6).toUpperCase();
    }
    return z.nr;
  }

  /* ---------- Schritt 1: Typ ---------- */
  function typen() {
    var vorhanden = {};
    daten.forEach(function (d) { if (d.hk) (vorhanden[d.hk] = vorhanden[d.hk] || []).push(d); });
    var reihe = TYP_REIHE.filter(function (t) { return vorhanden[t]; })
      .concat(Object.keys(vorhanden).filter(function (t) { return TYP_REIHE.indexOf(t) < 0; }));
    var html = reihe.map(function (t) {
      var ds = vorhanden[t], hmin = null, hmax = null;
      ds.forEach(function (d) {
        if (d.hmin != null && (hmin == null || d.hmin < hmin)) hmin = d.hmin;
        if (d.hmax != null && (hmax == null || d.hmax > hmax)) hmax = d.hmax;
      });
      return '<label class="pfk__kachel"><input type="radio" name="pfk_typ" value="' + esc(t) + '"' + (z.typ === t ? ' checked' : '') + '>' +
        '<span class="pfk__kachel-in"><span class="pfk__skizze pfk__skizze--' + (TYP_REIHE.indexOf(t) + 1) + '" aria-hidden="true"></span>' +
        '<b>' + esc(t) + '</b><small>' + esc(TYP_TEXT[t] || '') + '</small>' +
        (hmin != null ? '<small class="pfk__fakt">Höhe laut Hersteller: ' + esc(spanne(hmin, hmax, 'm')) + '</small>' : '') +
        '<small class="pfk__fakt">' + ds.length + ' Modell' + (ds.length === 1 ? '' : 'e') + '</small></span></label>';
    }).join('');
    html += '<label class="pfk__kachel pfk__kachel--alle"><input type="radio" name="pfk_typ" value="alle"' + (z.typ === 'alle' ? ' checked' : '') + '>' +
      '<span class="pfk__kachel-in"><b>Weiß ich noch nicht</b><small>Alle ' + daten.length + ' Modelle anzeigen</small></span></label>';
    $('[data-pfk-typen]').innerHTML = html;
  }

  /* ---------- Schritt 2: Modell ---------- */
  var herstFilter = '';
  function modelle() {
    var liste = daten.filter(function (d) { return z.typ === 'alle' || !z.typ || d.hk === z.typ; });
    var herst = []; liste.forEach(function (d) { if (herst.indexOf(d.v) < 0) herst.push(d.v); });
    if (herst.indexOf(herstFilter) < 0) herstFilter = '';
    $('[data-pfk-herst]').innerHTML = herst.length > 1 ? ['', ].concat(herst).map(function (h) {
      return '<button type="button" class="pfk__chip" data-herst="' + esc(h) + '" aria-pressed="' + (h === herstFilter) + '">' + esc(h || 'Alle Hersteller') + '</button>';
    }).join('') : '';
    if (herstFilter) liste = liste.filter(function (d) { return d.v === herstFilter; });
    $('[data-pfk-modelle]').innerHTML = liste.map(function (d) {
      var fakten = [];
      if (d.bmin != null) fakten.push('Breite ' + spanne(d.bmin, d.bmax, 'm'));
      if (d.hmin != null) fakten.push('Höhe ' + spanne(d.hmin, d.hmax, 'm'));
      return '<label class="pfk__modell"><input type="radio" name="pfk_modell" value="' + esc(d.h) + '"' + (z.modell === d.h ? ' checked' : '') + '>' +
        '<span class="pfk__modell-in">' + (d.img ? '<img src="' + esc(d.img) + '" alt="' + esc(d.alt) + '" loading="lazy" width="640" height="427">' : '<span class="pfk__noimg">Kein Bild</span>') +
        '<span class="pfk__modell-txt"><small class="pfk__vendor">' + esc(d.v) + (d.linie ? ' · ' + esc(d.linie) : '') + '</small><b>' + esc(d.t) + '</b>' +
        (d.ein ? '<small>' + esc(d.ein) + '</small>' : '') + (fakten.length ? '<small class="pfk__fakt">' + esc(fakten.join(' · ')) + '</small>' : '') +
        '<a href="' + esc(d.u) + '" target="_blank" rel="noopener" class="pfk__mehr">Details ansehen</a></span></span></label>';
    }).join('') || '<p>Für diese Auswahl sind keine Modelle vorhanden.</p>';
  }

  /* ---------- Schritt 3: Masse ---------- */
  function masse() {
    var d = modell(); if (!d) return;
    var m = z.masse, html = '';
    html += '<div class="pfk__info"><b>' + esc(d.t) + '</b>';
    var inf = [];
    if (d.bmin != null) inf.push('Breite der Überdachung: ' + spanne(d.bmin, d.bmax, 'm'));
    if (d.lmin != null) inf.push('Länge: ' + spanne(d.lmin, d.lmax, 'm'));
    if (d.hmin != null) inf.push('Höhe: ' + spanne(d.hmin, d.hmax, 'm'));
    html += inf.length ? '<br><small>Laut Hersteller – ' + esc(inf.join(' · ')) + '</small>' : '<br><small>Maße werden individuell passend zu Ihrem Becken geplant.</small>';
    html += '</div>';

    if (d.groessen && d.groessen.length) {
      html += '<p class="pfk__hilfe">Die e-line gibt es in festen Größen passend zu gängigen Beckenmaßen. Bitte wählen Sie Ihre Größe:</p><div class="pfk__liste">' +
        d.groessen.map(function (g) {
          return '<label class="pfk__zeile"><input type="radio" name="pfk_groesse" value="' + esc(g.id) + '"' + (String(z.groesse) === String(g.id) ? ' checked' : '') + '>' +
            '<span>' + esc(g.t) + '</span><b>' + esc(g.preis) + '</b></label>';
        }).join('') + '</div>' + (d.hinweis ? '<p class="pfk__klein">' + esc(d.hinweis) + '</p>' : '');
      html += '<p class="pfk__hilfe" style="margin-top:22px">Optional: genaue Außenmaße Ihres Beckens (inkl. Umrandung)</p>';
    } else {
      html += '<p class="pfk__hilfe">Unsere Überdachungen werden nach Maß gefertigt. Geben Sie die Außenmaße der Beckenumrandung an – oder, falls keine Umrandung vorhanden ist, die Außenmaße des Beckenrandes.</p>';
    }
    var pflicht = !(d.groessen && d.groessen.length);
    html += '<div class="pfk__felder pfk__felder--masse">' +
      '<label>Beckenbreite (cm)' + (pflicht ? '*' : '') + '<input type="number" min="100" max="2000" step="1" inputmode="numeric" data-mass="breite" value="' + esc(m.breite) + '" placeholder="z. B. 350"></label>' +
      '<label>Beckenlänge (cm)' + (pflicht ? '*' : '') + '<input type="number" min="100" max="4000" step="1" inputmode="numeric" data-mass="laenge" value="' + esc(m.laenge) + '" placeholder="z. B. 800"></label></div>' +
      '<div class="pfk__warn" data-pfk-breitenhinweis hidden></div>' +
      '<label class="pfk__check"><input type="checkbox" data-mass="abstand"' + (m.abstand ? ' checked' : '') + '> <span>Ich wünsche mehr Platz um das Becken herum (Abstand zwischen Becken und Überdachung selbst festlegen)</span></label>' +
      '<div class="pfk__felder pfk__felder--masse" data-pfk-abstand' + (m.abstand ? '' : ' hidden') + '>' +
      '<label>Abstand seitlich, je Seite (cm)<input type="number" min="0" max="300" step="1" data-mass="abstandB" value="' + esc(m.abstandB) + '"></label>' +
      '<label>Abstand vorne/hinten, je Seite (cm)<input type="number" min="0" max="500" step="1" data-mass="abstandL" value="' + esc(m.abstandL) + '"></label></div>' +
      '<label class="pfk__breit">Anmerkungen zu den Maßen (z. B. Beckenform, Gefälle, Hindernisse)<textarea rows="3" data-mass="notiz">' + esc(m.notiz) + '</textarea></label>';
    $('[data-pfk-masse]').innerHTML = html;
    breitenHinweis();
  }
  function breitenHinweis() {
    var d = modell(), el = $('[data-pfk-breitenhinweis]'); if (!d || !el) return;
    var b = parseFloat(z.masse.breite);
    if (b && d.bmax != null && b / 100 > d.bmax) {
      el.hidden = false;
      el.textContent = 'Hinweis: Ihr Becken ist breiter als die größte Überdachungsbreite dieses Modells laut Hersteller (' + zahl(d.bmax) + ' m). Sie können trotzdem anfragen – wir prüfen Ihre Situation und schlagen passende Alternativen vor.';
    } else el.hidden = true;
  }

  /* ---------- Schritt 4: Farbe ---------- */
  function farben() {
    var d = modell(); if (!d) return;
    var fs = d.farben || [], sonder = (d.optionen || []).filter(istSonderfarbe)[0];
    var html = '';
    if (!fs.length && !sonder) {
      html = '<p class="pfk__hilfe">Für dieses Modell sind beim Hersteller keine Farben zur Auswahl hinterlegt. Die Farbe klären wir gerne im Angebot.</p>' +
        '<label class="pfk__breit">Ihr Farbwunsch (optional)<input data-pfk-ralfeld value="' + esc(z.ral) + '" placeholder="z. B. anthrazit"></label>';
    } else {
      html = '<div class="pfk__farben">' + fs.map(function (f) {
        var code = (f.match(/RAL\s*(\d{4})/) || [])[1], farbe = RAL[code] || '#c9ccce';
        var zweifarbig = /silbereloxiert/i.test(f);
        return '<label class="pfk__farbe"><input type="radio" name="pfk_farbe" value="' + esc(f) + '"' + (z.farbe === f ? ' checked' : '') + '>' +
          '<span class="pfk__farbe-in"><span class="pfk__muster" style="background:' + (zweifarbig ? 'linear-gradient(135deg,' + farbe + ' 50%,#c8ccd0 50%)' : farbe) + '"></span>' + esc(f) + '</span></label>';
      }).join('');
      if (sonder) {
        html += '<label class="pfk__farbe"><input type="radio" name="pfk_farbe" value="' + esc(sonder) + '"' + (z.farbe === sonder ? ' checked' : '') + '>' +
          '<span class="pfk__farbe-in"><span class="pfk__muster pfk__muster--sonder"></span>' + esc(sonder) + '</span></label>';
      }
      html += '</div>';
      if (sonder) html += '<label class="pfk__breit" data-pfk-ral' + (z.farbe === sonder ? '' : ' hidden') + '>RAL-Code bzw. Dekor*<input data-pfk-ralfeld value="' + esc(z.ral) + '" placeholder="RAL-Code"></label>';
      html += '<p class="pfk__klein">Die Farbmuster auf dem Bildschirm sind nur Anhaltspunkte. Verbindlich ist der RAL-Farbton.</p>';
    }
    $('[data-pfk-farben]').innerHTML = html;
  }

  /* ---------- Schritt 5: Optionen ---------- */
  function optionen() {
    var d = modell(); if (!d) return;
    var os = (d.optionen || []).filter(function (o) { return !istSonderfarbe(o); });
    var html = '';
    (d.wahl || []).forEach(function (w) {
      html += '<fieldset class="pfk__gruppe"><legend>' + esc(w.n) + '</legend>' + w.w.map(function (v) {
        return '<label class="pfk__zeile"><input type="radio" name="pfk_wahl_' + esc(w.n) + '" data-wahl="' + esc(w.n) + '" value="' + esc(v) + '"' + (z.wahl[w.n] === v ? ' checked' : '') + '><span>' + esc(v) + '</span></label>';
      }).join('') + '</fieldset>';
    });
    if (os.length) {
      html += '<fieldset class="pfk__gruppe"><legend>Optionale Ausstattung laut Hersteller</legend>' + os.map(function (o) {
        return '<label class="pfk__zeile"><input type="checkbox" data-opt value="' + esc(o) + '"' + (z.optionen.indexOf(o) > -1 ? ' checked' : '') + '><span>' + esc(o) + '</span></label>';
      }).join('') + '</fieldset>';
    } else if (!(d.wahl || []).length) {
      html += '<p class="pfk__hilfe">Für dieses Modell sind beim Hersteller keine zusätzlichen Optionen hinterlegt.</p>';
    }
    if (d.serie && d.serie.length) {
      html += '<div class="pfk__serie"><b>Bereits serienmäßig enthalten:</b><ul>' + d.serie.map(function (s) { return '<li>' + esc(s) + '</li>'; }).join('') + '</ul></div>';
    }
    html += '<fieldset class="pfk__gruppe"><legend>Montage</legend>' + ['Ja, bitte mit Montage anbieten', 'Nein, ich montiere selbst', 'Bitte beraten Sie mich'].map(function (v) {
      return '<label class="pfk__zeile"><input type="radio" name="pfk_montage" data-montage value="' + esc(v) + '"' + (z.montage === v ? ' checked' : '') + '><span>' + esc(v) + '</span></label>';
    }).join('') + '</fieldset>' +
      '<label class="pfk__breit">Weitere Wünsche zur Ausstattung (optional)<textarea rows="3" data-pfk-optnotiz>' + esc(z.optNotiz) + '</textarea></label>';
    $('[data-pfk-optionen]').innerHTML = html;
  }

  /* ---------- Zusammenfassung ---------- */
  function zeilen() {
    var d = modell(); if (!d) return [];
    var g = null; (d.groessen || []).forEach(function (x) { if (String(x.id) === String(z.groesse)) g = x; });
    var m = z.masse, r = [];
    r.push(['Modell', [['Hersteller', d.v], ['Modell', d.t], ['Bauhöhe', d.hk || ''], ['Einordnung', d.ein || '']]]);
    var mz = [];
    if (g) { mz.push(['Größe', g.t]); if (g.sku) mz.push(['Artikelnummer', g.sku]); mz.push(['Preis', g.preis + (d.hinweis ? ' (' + d.hinweis + ')' : '')]); }
    if (m.breite) mz.push(['Beckenbreite (außen)', m.breite + ' cm']);
    if (m.laenge) mz.push(['Beckenlänge (außen)', m.laenge + ' cm']);
    if (m.abstand) {
      if (m.abstandB) mz.push(['Abstand seitlich je Seite', m.abstandB + ' cm']);
      if (m.abstandL) mz.push(['Abstand vorne/hinten je Seite', m.abstandL + ' cm']);
    }
    if (m.notiz) mz.push(['Anmerkungen', m.notiz]);
    if (d.bmin != null) mz.push(['Breite der Überdachung laut Hersteller', spanne(d.bmin, d.bmax, 'm')]);
    if (d.hmin != null) mz.push(['Höhe laut Hersteller', spanne(d.hmin, d.hmax, 'm')]);
    r.push(['Abmessungen', mz.length ? mz : [['Maße', 'keine Angabe']]]);
    var fz = [];
    if (z.farbe) fz.push(['Farbe', z.farbe]);
    if (z.ral) fz.push([z.farbe && istSonderfarbe(z.farbe) ? 'RAL-Code / Dekor' : 'Farbwunsch', z.ral]);
    r.push(['Farbe', fz.length ? fz : [['Farbe', 'Klärung im Angebot']]]);
    var oz = [];
    Object.keys(z.wahl).forEach(function (k) { if (z.wahl[k]) oz.push([k, z.wahl[k]]); });
    z.optionen.forEach(function (o) { oz.push(['Option', o]); });
    if (z.montage) oz.push(['Montage', z.montage]);
    if (z.optNotiz) oz.push(['Weitere Wünsche', z.optNotiz]);
    r.push(['Optionen', oz.length ? oz : [['Optionen', 'keine gewählt']]]);
    if (d.serie && d.serie.length) r.push(['Serienmäßig enthalten', d.serie.map(function (s) { return ['', s]; })]);
    return r;
  }
  function uebersicht() {
    var d = modell(); if (!d) return;
    var html = '<div class="pfk__uebersicht">' + (d.img ? '<img src="' + esc(d.img) + '" alt="' + esc(d.alt) + '" width="640" height="427">' : '') + '<div>';
    zeilen().forEach(function (blk) {
      html += '<h3>' + esc(blk[0]) + '</h3><dl>' + blk[1].map(function (x) { return (x[0] ? '<dt>' + esc(x[0]) + '</dt>' : '<dt>✓</dt>') + '<dd>' + esc(x[1]) + '</dd>'; }).join('') + '</dl>';
    });
    html += '<p class="pfk__klein">Alle technischen Angaben laut Hersteller. Die Konfiguration ist eine unverbindliche Anfrage – Ihr persönliches Angebot erhalten Sie von uns.</p>';
    $('[data-pfk-uebersicht]').innerHTML = html + '</div></div>';
  }
  function kunde() {
    var f = $('[data-pfk-form]'); if (!f) return {};
    function w(n) { var el = f.querySelector('[name="contact[' + n + ']"]'); return el ? el.value.trim() : ''; }
    return { anrede: w('Anrede'), vorname: w('Vorname'), nachname: w('Nachname'), email: w('email'), telefon: w('Telefon'),
      strasse: w('Strasse'), plz: w('PLZ'), ort: w('Ort'), land: w('Land'), quelle: w('Quelle'), nachricht: w('Nachricht') };
  }
  function klartext() {
    var t = 'KONFIGURATION POOLÜBERDACHUNG\nAnfrage-Nr.: ' + anfrageNr() + '\n';
    zeilen().forEach(function (blk) {
      t += '\n' + blk[0].toUpperCase() + '\n';
      blk[1].forEach(function (x) { t += (x[0] ? x[0] + ': ' : '- ') + x[1] + '\n'; });
    });
    var d = modell(); if (d) t += '\nProduktseite: ' + (cfg.web || '') + d.u + '\n';
    return t;
  }

  /* Absenden-Button erst aktiv, wenn im letzten Schritt alle Pflichtfelder ausgefuellt sind */
  function sendenPruefen() {
    var sen = $('[data-pfk-senden]'), s7 = $('[data-schritt="' + MAX + '"]');
    if (!sen || !s7) return;
    var ok = schritt === MAX && $$('input,select,textarea', s7).every(function (el) { return el.checkValidity(); });
    sen.disabled = !ok;
    sen.title = ok ? '' : 'Bitte füllen Sie alle Pflichtfelder aus und bestätigen Sie die Datenschutzerklärung.';
  }

  /* ---------- Navigation ---------- */
  function fehler(txt) { var el = $('[data-pfk-meldung]'); if (el) el.textContent = txt || ''; return !txt; }
  function pruefen(s) {
    var d = modell();
    if (s === 1 && !z.typ) return fehler('Bitte wählen Sie eine Bauhöhe.');
    if (s === 2 && !d) return fehler('Bitte wählen Sie ein Modell.');
    if (s === 3) {
      if (d.groessen && d.groessen.length) { if (!z.groesse) return fehler('Bitte wählen Sie eine Größe.'); }
      else if (!(parseFloat(z.masse.breite) > 0 && parseFloat(z.masse.laenge) > 0)) return fehler('Bitte geben Sie Breite und Länge Ihres Beckens an.');
    }
    if (s === 4) {
      var mitFarben = (d.farben && d.farben.length) || (d.optionen || []).some(istSonderfarbe);
      if (mitFarben && !z.farbe) return fehler('Bitte wählen Sie eine Farbe.');
      if (z.farbe && istSonderfarbe(z.farbe) && !z.ral) return fehler('Bitte geben Sie den gewünschten RAL-Code an.');
    }
    if (s === 5) {
      var offen = (d.wahl || []).filter(function (w) { return !z.wahl[w.n]; })[0];
      if (offen) return fehler('Bitte wählen Sie: ' + offen.n + '.');
    }
    return fehler('');
  }
  function zeigen(s) {
    schritt = s;
    $$('[data-schritt]').forEach(function (el) { el.hidden = Number(el.getAttribute('data-schritt')) !== s; });
    $$('[data-pfk-leiste] li').forEach(function (li) {
      var n = Number(li.getAttribute('data-s'));
      li.className = n === s ? 'ist-aktiv' : (n < s ? 'ist-fertig' : '');
    });
    if (s === 1) typen();
    if (s === 2) modelle();
    if (s === 3) masse();
    if (s === 4) farben();
    if (s === 5) optionen();
    if (s === 6) uebersicht();
    var zur = $('[data-pfk-zurueck]'), wei = $('[data-pfk-weiter]'), sen = $('[data-pfk-senden]');
    if (zur) zur.hidden = s === 1;
    if (wei) { wei.hidden = s === MAX; wei.textContent = s === 6 ? 'Weiter zur Anfrage' : 'Weiter'; }
    if (sen) sen.hidden = s !== MAX;
    sendenPruefen();
    fehler('');
    schreiben();
    var kopf = root.getBoundingClientRect().top + window.pageYOffset - 90;
    if (window.pageYOffset > kopf) window.scrollTo({ top: kopf, behavior: 'smooth' });
  }

  /* ---------- Ereignisse ---------- */
  root.addEventListener('change', function (e) {
    var t = e.target;
    if (t.name === 'pfk_typ') { z.typ = t.value; if (z.modell && modell() && z.typ !== 'alle' && modell().hk !== z.typ) z.modell = ''; zeigen(2); return; }
    if (t.name === 'pfk_modell') {
      if (z.modell !== t.value) { z.modell = t.value; z.groesse = ''; z.farbe = ''; z.ral = ''; z.optionen = []; z.wahl = {}; }
      var d = modell(); if (d && d.farben && d.farben.length === 1) z.farbe = d.farben[0];
      zeigen(3); return;
    }
    if (t.name === 'pfk_groesse') z.groesse = t.value;
    if (t.hasAttribute('data-mass')) {
      var k = t.getAttribute('data-mass');
      z.masse[k] = t.type === 'checkbox' ? t.checked : t.value;
      if (k === 'abstand') { var a = $('[data-pfk-abstand]'); if (a) a.hidden = !t.checked; }
    }
    if (t.name === 'pfk_farbe') { z.farbe = t.value; var r = $('[data-pfk-ral]'); if (r) r.hidden = !istSonderfarbe(t.value); }
    if (t.hasAttribute('data-opt')) z.optionen = $$('[data-opt]:checked').map(function (x) { return x.value; });
    if (t.hasAttribute('data-wahl')) z.wahl[t.getAttribute('data-wahl')] = t.value;
    if (t.hasAttribute('data-montage')) z.montage = t.value;
    sendenPruefen();
    schreiben();
  });
  root.addEventListener('input', function (e) {
    var t = e.target;
    if (t.hasAttribute('data-mass') && t.type !== 'checkbox') { z.masse[t.getAttribute('data-mass')] = t.value; breitenHinweis(); }
    if (t.hasAttribute('data-pfk-ralfeld')) z.ral = t.value.trim();
    if (t.hasAttribute('data-pfk-optnotiz')) z.optNotiz = t.value;
    sendenPruefen();
    schreiben();
  });
  root.addEventListener('click', function (e) {
    var h = e.target.closest('[data-herst]');
    if (h) { herstFilter = h.getAttribute('data-herst'); modelle(); return; }
    if (e.target.closest('[data-pfk-weiter]')) { if (pruefen(schritt)) zeigen(Math.min(MAX, schritt + 1)); return; }
    if (e.target.closest('[data-pfk-zurueck]')) { zeigen(Math.max(1, schritt - 1)); return; }
    if (e.target.closest('[data-pfk-pdf]')) { e.preventDefault(); pdfErstellen(false).then(function (doc) { if (doc) doc.save(dateiname()); }); }
    var li = e.target.closest('[data-pfk-leiste] li');
    if (li && !gesendet && schritt) {
      var ziel = Number(li.getAttribute('data-s'));
      if (ziel < schritt) zeigen(ziel);
      else { for (var s = schritt; s < ziel; s++) { if (!pruefen(s)) { zeigen(s); pruefen(s); return; } } zeigen(ziel); }
    }
  });

  /* ---------- Absenden ---------- */
  var form = $('[data-pfk-form]');
  var sendetGerade = false;
  if (form && !gesendet) {
    form.addEventListener('submit', function (e) {
      if (sendetGerade) return;
      for (var s = 1; s < MAX; s++) { if (!pruefen(s)) { e.preventDefault(); zeigen(s); pruefen(s); return; } }
      var k = kunde();
      var txt = klartext() + '\nKONTAKT\n' + [k.anrede, k.vorname, k.nachname].filter(Boolean).join(' ') + '\n' + k.email + '\n' + k.telefon + '\n' +
        [k.strasse, [k.plz, k.ort].filter(Boolean).join(' '), k.land].filter(Boolean).join(', ') + (k.nachricht ? '\n\nNachricht:\n' + k.nachricht : '');
      $('[data-pfk-body]').value = txt;
      var d = modell(); $('[data-pfk-modellfeld]').value = d ? voll(d) + ' (' + anfrageNr() + ')' : '';
      z.kunde = k; schreiben();
      if (!cfg.versand) return; /* nur Kontaktformular */
      e.preventDefault();
      sendetGerade = true;
      var btn = $('[data-pfk-senden]'); if (btn) { btn.disabled = true; btn.textContent = 'Wird gesendet …'; }
      pdfErstellen(true).then(function (doc) {
        var hp = $('[data-pfk-hp]');
        var nutz = { anfrage: anfrageNr(), kunde: k, modell: d ? voll(d) : '', produkt: d ? (cfg.web || '') + d.u : '',
          bloecke: zeilen(), konfiguration: klartext(), dateiname: dateiname(), website: hp ? hp.value : '',
          pdf: doc ? doc.output('datauristring').split(',')[1] : null };
        var zeit = new Promise(function (ok) { setTimeout(function () { ok(null); }, 25000); });
        return Promise.race([fetch(cfg.versand, { method: 'POST', headers: { 'Content-Type': 'text/plain;charset=utf-8' }, body: JSON.stringify(nutz) })
          .then(function (r) { return r.ok ? r.json().catch(function () { return null; }) : null; }).catch(function () { return null; }), zeit]);
      }).then(function (antwort) {
        if (antwort && antwort.ok) { z.mailOk = true; schreiben(); dankeZeigen(); }
        else { z.mailOk = false; schreiben(); form.submit(); /* Rueckfall: Shopify-Kontaktformular */ }
      }).catch(function () { form.submit(); });
    });
  }

  function dankeZeigen() {
    gesendet = true;
    form.innerHTML = '<section class="pfk__schritt pfk__danke"><h2>Vielen Dank für Ihre Anfrage!</h2>' +
      '<p>Ihre Konfiguration ist bei uns eingegangen. Wir prüfen Ihre Angaben und melden uns in Kürze mit einem persönlichen Angebot bei Ihnen.</p>' +
      '<p>Eine Bestätigung mit Ihrer Konfiguration als PDF haben wir Ihnen per E-Mail gesendet.</p>' +
      '<div class="pfk__aktionen"><button type="button" class="pfw__btn" data-pfk-pdf>Konfiguration als PDF herunterladen</button>' +
      '<a class="pfw__btn pfw__btn--ghost" href="' + esc(cfg.zurueck || '/collections/pooluberdachungen') + '">Zu den Poolüberdachungen</a></div></section>';
    $$('[data-pfk-leiste] li').forEach(function (li) { li.className = 'ist-fertig'; });
    var kopf = root.getBoundingClientRect().top + window.pageYOffset - 90;
    window.scrollTo({ top: kopf, behavior: 'smooth' });
  }

  /* ---------- PDF ---------- */
  function dateiname() { var d = modell(); return 'Poolfritz-Konfiguration-' + (d ? d.t.replace(/[^A-Za-z0-9]+/g, '-') : 'Ueberdachung') + '-' + anfrageNr() + '.pdf'; }
  var jspdfLaden = null;
  function ladeJsPDF() {
    if (window.jspdf) return Promise.resolve(window.jspdf.jsPDF);
    if (!jspdfLaden) jspdfLaden = new Promise(function (ok, nein) {
      var s = document.createElement('script');
      s.src = 'https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js';
      s.onload = function () { ok(window.jspdf.jsPDF); }; s.onerror = nein; document.head.appendChild(s);
    });
    return jspdfLaden;
  }
  function bildLaden(url, format) {
    return new Promise(function (ok) {
      if (!url) return ok(null);
      var img = new Image(); img.crossOrigin = 'anonymous';
      img.onload = function () {
        try {
          var c = document.createElement('canvas'); c.width = img.naturalWidth; c.height = img.naturalHeight;
          var cx = c.getContext('2d');
          if (format === 'JPEG') { cx.fillStyle = '#fff'; cx.fillRect(0, 0, c.width, c.height); }
          cx.drawImage(img, 0, 0);
          ok({ data: c.toDataURL(format === 'JPEG' ? 'image/jpeg' : 'image/png', 0.88), w: c.width, h: c.height, f: format });
        } catch (e) { ok(null); }
      };
      img.onerror = function () { ok(null); };
      img.src = (url.indexOf('//') === 0 ? 'https:' : '') + url;
    });
  }
  function pdfErstellen(still) {
    var d = modell();
    if (!d) { if (!still) alert('Bitte wählen Sie zuerst ein Modell.'); return Promise.resolve(null); }
    var btns = $$('[data-pfk-pdf]'); btns.forEach(function (b) { b.disabled = true; });
    return Promise.all([ladeJsPDF(), bildLaden(cfg.logo, 'PNG'), bildLaden(d.pdfimg || d.img, 'JPEG')]).then(function (r) {
      var doc = pdfBauen(r[0], r[1], r[2], d);
      btns.forEach(function (b) { b.disabled = false; });
      return doc;
    }).catch(function () {
      btns.forEach(function (b) { b.disabled = false; });
      if (!still) alert('Das PDF konnte gerade nicht erstellt werden. Bitte versuchen Sie es erneut.');
      return null;
    });
  }
  function pdfBauen(JsPDF, logo, bild, d) {
    var doc = new JsPDF({ unit: 'mm', format: 'a4' });
    var W = 210, L = 18, R = 192, y = 16, BLAU = [6, 20, 46], GRAU = [110, 116, 124], LINIE = [220, 224, 228];
    var heute = new Date().toLocaleDateString('de-DE');
    function kopf() {
      if (logo) { var lh = 16, lw = Math.min(60, lh * logo.w / logo.h); doc.addImage(logo.data, 'PNG', L, 10, lw, lw * logo.h / logo.w); }
      else { doc.setFont('helvetica', 'bold'); doc.setFontSize(18); doc.setTextColor.apply(doc, BLAU); doc.text(cfg.shop || 'Poolfritz', L, 20); }
      doc.setFont('helvetica', 'normal'); doc.setFontSize(9); doc.setTextColor.apply(doc, GRAU);
      doc.text('Anfrage-Nr. ' + anfrageNr(), R, 14, { align: 'right' });
      doc.text('Datum ' + heute, R, 19, { align: 'right' });
      doc.setDrawColor.apply(doc, LINIE); doc.line(L, 30, R, 30);
      y = 38;
    }
    function neueSeite(bedarf) { if (y + bedarf > 275) { doc.addPage(); kopf(); } }
    kopf();
    doc.setFont('helvetica', 'bold'); doc.setFontSize(20); doc.setTextColor.apply(doc, BLAU);
    doc.text('Ihre Poolüberdachung', L, y); y += 7;
    doc.setFont('helvetica', 'normal'); doc.setFontSize(11); doc.setTextColor(60, 60, 60);
    doc.text(voll(d) + (d.hk ? '  ·  Bauhöhe: ' + d.hk : ''), L, y); y += 6;

    /* Bild der Ueberdachung */
    if (bild) {
      var bw = R - L, bh = bw * bild.h / bild.w; if (bh > 85) { bh = 85; bw = bh * bild.w / bild.h; }
      doc.addImage(bild.data, 'JPEG', L + (R - L - bw) / 2, y, bw, bh); y += bh + 3;
      doc.setFontSize(8); doc.setTextColor.apply(doc, GRAU); doc.text('Abbildung ähnlich, Beispielfoto des Herstellers.', L, y + 1); y += 7;
    }

    /* Skizze Draufsicht (nur mit Kundenmassen) */
    var b = parseFloat(z.masse.breite), l = parseFloat(z.masse.laenge);
    if (b > 0 && l > 0) {
      neueSeite(62);
      doc.setFont('helvetica', 'bold'); doc.setFontSize(11); doc.setTextColor.apply(doc, BLAU); doc.text('Skizze – Draufsicht (Ihre Angaben)', L, y); y += 4;
      var ab = z.masse.abstand ? (parseFloat(z.masse.abstandB) || 0) : 0, al = z.masse.abstand ? (parseFloat(z.masse.abstandL) || 0) : 0;
      var gesB = b + 2 * ab, gesL = l + 2 * al, maxW = 120, maxH = 46, k = Math.min(maxW / gesL, maxH / gesB);
      var x0 = L + 30, y0 = y + 6;
      doc.setDrawColor(150, 160, 170); doc.setLineDashPattern([1.5, 1.2], 0); doc.setLineWidth(0.4);
      doc.rect(x0, y0, gesL * k, gesB * k);
      doc.setLineDashPattern([], 0); doc.setFillColor(170, 214, 240); doc.setDrawColor(30, 110, 170); doc.setLineWidth(0.5);
      doc.rect(x0 + al * k, y0 + ab * k, l * k, b * k, 'FD');
      doc.setFont('helvetica', 'normal'); doc.setFontSize(8.5); doc.setTextColor(40, 40, 40);
      doc.text('Becken ' + l + ' × ' + b + ' cm', x0 + (gesL * k) / 2, y0 + (gesB * k) / 2 + 1, { align: 'center' });
      doc.setTextColor.apply(doc, GRAU);
      doc.text('Länge ' + l + ' cm', x0 + (gesL * k) / 2, y0 + gesB * k + 5, { align: 'center' });
      doc.text('Breite ' + b + ' cm', x0 - 3, y0 + (gesB * k) / 2, { align: 'right' });
      if (ab || al) doc.text('gestrichelt: gewünschter Innenraum der Überdachung (Abstand ' + (ab || 0) + ' cm seitlich / ' + (al || 0) + ' cm vorne und hinten)', L, y0 + gesB * k + 10);
      y = y0 + gesB * k + (ab || al ? 16 : 11);
    }

    /* Tabellen */
    var k2 = z.kunde || kunde();
    var bloecke = zeilen();
    var kz = [];
    var name = [k2.anrede, k2.vorname, k2.nachname].filter(Boolean).join(' ');
    if (name) kz.push(['Name', name]);
    if (k2.email) kz.push(['E-Mail', k2.email]);
    if (k2.telefon) kz.push(['Telefon', k2.telefon]);
    var adr = [k2.strasse, [k2.plz, k2.ort].filter(Boolean).join(' '), k2.land].filter(Boolean).join(', ');
    if (adr && (k2.strasse || k2.plz || k2.ort)) kz.push(['Adresse', adr]);
    if (k2.nachricht) kz.push(['Nachricht', k2.nachricht]);
    if (kz.length) bloecke.push(['Ihre Kontaktdaten', kz]);
    bloecke.forEach(function (blk) {
      neueSeite(16);
      doc.setFont('helvetica', 'bold'); doc.setFontSize(11); doc.setTextColor.apply(doc, BLAU); doc.text(blk[0], L, y); y += 2;
      doc.setDrawColor.apply(doc, LINIE); doc.line(L, y, R, y); y += 5;
      blk[1].forEach(function (x) {
        doc.setFontSize(9.5);
        var wert = doc.splitTextToSize(String(x[1]), x[0] ? 112 : 168);
        neueSeite(wert.length * 4.4 + 2);
        doc.setFont('helvetica', 'normal'); doc.setTextColor.apply(doc, GRAU);
        if (x[0]) doc.text(doc.splitTextToSize(x[0], 56), L, y); else doc.text('–', L + 2, y);
        doc.setTextColor(30, 30, 30);
        doc.text(wert, x[0] ? L + 62 : L + 8, y);
        y += Math.max(wert.length, x[0] ? doc.splitTextToSize(x[0], 56).length : 1) * 4.4 + 1.6;
      });
      y += 4;
    });
    neueSeite(20);
    doc.setFont('helvetica', 'normal'); doc.setFontSize(8.5); doc.setTextColor.apply(doc, GRAU);
    doc.text(doc.splitTextToSize('Diese Konfiguration ist eine unverbindliche Anfrage und kein Angebot. Alle technischen Angaben laut Hersteller, technische Änderungen vorbehalten. Wir prüfen Ihre Angaben und senden Ihnen ein persönliches Angebot.', R - L), L, y);

    var seiten = doc.getNumberOfPages();
    for (var i = 1; i <= seiten; i++) {
      doc.setPage(i); doc.setFontSize(8); doc.setTextColor.apply(doc, GRAU); doc.setDrawColor.apply(doc, LINIE);
      doc.line(L, 283, R, 283);
      var fuss = [cfg.shop || 'Poolfritz', cfg.mail, cfg.telefon, (cfg.web || '').replace(/^https?:\/\//, '')].filter(Boolean).join('  ·  ');
      doc.text(fuss, L, 288); doc.text('Seite ' + i + ' von ' + seiten, R, 288, { align: 'right' });
    }
    return doc;
  }

  /* ---------- Start ---------- */
  if (gesendet) {
    var alt = lesen();
    if (alt && alt.modell && nachHandle[alt.modell]) {
      z = alt;
      $$('[data-pfk-pdf]').forEach(function (b) { b.hidden = false; });
      if (z.mailOk) { var m = $('[data-pfk-danke-mail]'); if (m) m.hidden = false; }
    }
    $$('[data-pfk-leiste] li').forEach(function (li) { li.className = 'ist-fertig'; });
    return;
  }
  var params = new URLSearchParams(window.location.search);
  var gespeichert = lesen();
  if (gespeichert && !params.get('modell')) { z = gespeichert; z.kunde = null; }
  var vorwahl = params.get('modell');
  if (vorwahl && nachHandle[vorwahl]) {
    var neu = z.modell !== vorwahl;
    if (neu) { z.groesse = ''; z.farbe = ''; z.ral = ''; z.optionen = []; z.wahl = {}; z.nr = ''; }
    z.modell = vorwahl; z.typ = nachHandle[vorwahl].hk || 'alle';
    var v = params.get('variante');
    if (v && (nachHandle[vorwahl].groessen || []).some(function (g) { return String(g.id) === v; })) z.groesse = v;
    if (nachHandle[vorwahl].farben && nachHandle[vorwahl].farben.length === 1) z.farbe = nachHandle[vorwahl].farben[0];
    zeigen(3);
  } else {
    zeigen(z.modell && modell() ? 2 : 1);
  }
})();
